// External Dependencies
import Marionette from 'backbone.marionette';
import Backbone from 'backbone';

// Internal Dependencies - screens/views/templates
import bonusScoreContainerView  from '../../../../../templates/MIPS/AdvancingCare/Summary/bonusScoreContainerView';

// Internal Dependencies - models/collections

export default Marionette.ItemView.extend({

    className: 'col s6 prn',

    initialize: function() {
        this.channel = Backbone.Radio.channel( 'AppChannel' );
        this.app = this.channel.request( 'app' );
        this.listenTo( this.model, 'change:summaryData', this.render )
    },

    getTemplate: function() {
        return bonusScoreContainerView( this.model );
    },

});
